var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyAppointments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 75,
    viewBox: "0 0 72 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.375 41.0418V16.2502C66.375 14.3715 65.6287 12.5699 64.3003 11.2415C62.972 9.91311 61.1703 9.16683 59.2917 9.16683H9.70833C7.82972 9.16683 6.02804 9.91311 4.69966 11.2415C3.37128 12.5699 2.625 14.3715 2.625 16.2502V65.8335C2.625 67.7121 3.37128 69.5138 4.69966 70.8422C6.02804 72.1706 7.82972 72.9168 9.70833 72.9168H38.0417M48.6667 2.0835V16.2502M20.3333 2.0835V16.2502M2.625 30.4168H66.375M52.2083 55.2085L69.9167 72.9168M52.2083 72.9168L69.9167 55.2085",
    stroke: "#2B2724",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAppointments);
export default __webpack_public_path__ + "static/media/emptyAppointments.c7c2424fbed80bea6790d59e1ce17855.svg";
export { ForwardRef as ReactComponent };